export class Assets {
    constructor() {
        this._textures = {
            noise: null,
        }

    }

    setTexture({ key, texture }) {
        this._textures = {
            ...this._textures,
            [key]: texture
        }
    }

    get textures() {
        return this._textures;
    }

}